module.exports = __webpack_public_path__ + "img/logo.77be2107.png";